import { TabPanel } from 'components/shared/index';
import { MailFields } from './MailFields';
import { SMSFields } from './SMSFields';
import { useTranslation } from 'react-i18next';

interface Props {
  selectedTab: number;
}

export const FormContent = ({ selectedTab }: Props) => {
  const { t } = useTranslation('common', { keyPrefix: 'mailAndSMS' });
  return (
    <>
      <TabPanel title={t('mailSection.name')} index={0} value={selectedTab}>
        <MailFields />
      </TabPanel>
      <TabPanel title={t('smsSection.name')} index={1} value={selectedTab}>
        <SMSFields />
      </TabPanel>
    </>
  );
};
